module.exports = __webpack_public_path__ + "images/emoji/icecream.238d78bbdbd8447cbec2.png";